module.exports = __webpack_public_path__ + "img/multiphones-flat_jp.78ce4c8.jpg";